// settings/HamburgerMenu/sections/CameraSection.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from "~/components/utils/Accordion";
import { useAtom } from "jotai";
import {
  isFaceDetectionAtom,
  faceDistanceAtom,
  threshFaceSizeAtom,
  volumeAtom,
  isProcessingAtom,
} from "~/Atom";
import { PlaySound } from "~/SoundUtils";
import SliderController from "~/components/utils/SliderController";
import { cameraSettings } from "~/Commons";

/**
 * カメラ設定セクションコンポーネント
 */
const CameraSection: React.FC = () => {
  const { t } = useTranslation();
  const [isFaceDetection, setFaceDetection] = useAtom(isFaceDetectionAtom);
  const [faceDistance, setFaceDistance] = useAtom(faceDistanceAtom);
  const [, setThreshFaceSize] = useAtom(threshFaceSizeAtom);
  const [volume] = useAtom(volumeAtom);
  const [isProcessing] = useAtom(isProcessingAtom);

  const toggleFaceDetection = () => {
    setFaceDetection(!isFaceDetection);
  };

  const changeDistance = (value: number) => {
    setFaceDistance(value);
    setThreshFaceSize(cameraSettings.defaultThreshold - value);
  };

  return (
    <Accordion
      items={[
        {
          title: t("cameraSettings"),
          content: (
            <>
              <div className="child-content">
                <span className="title font-default-normal-20">{t("faceDetection")}</span>
                <div className="toggle-container" style={{ display: "flex", alignItems: "center" }}>
                  <button
                    className={`toggle-btn left font-default-bold-24 ${isFaceDetection ? "active" : ""}`}
                    onClick={toggleFaceDetection}
                    onMouseUp={() => PlaySound("push2", volume)}
                    disabled={isProcessing}
                  >
                    ON
                  </button>
                  <button
                    className={`toggle-btn right font-default-bold-24 ${!isFaceDetection ? "active" : ""}`}
                    onClick={toggleFaceDetection}
                    onMouseUp={() => PlaySound("push2", volume)}
                    disabled={isProcessing}
                  >
                    OFF
                  </button>
                </div>
              </div>
              <div>
                <div className="slider">
                  <div className="slider-container">
                    <span className="slider-title font-default-normal-20">
                      {t("distanceFromCamera")}
                    </span>
                    <div className="slider-content">
                      <input
                        type="range"
                        className="slider-input"
                        min={cameraSettings.minDistance}
                        max={cameraSettings.maxDistance}
                        value={faceDistance}
                        step={1}
                        style={
                          {
                            "--value": `${((faceDistance - cameraSettings.minDistance) / (cameraSettings.maxDistance - cameraSettings.minDistance)) * 100}%`,
                          } as React.CSSProperties
                        }
                        onChange={(e) => changeDistance(parseInt(e.target.value, 10))}
                      />
                      <SliderController
                        handleMinusValue={() =>
                          changeDistance(Math.max(cameraSettings.minDistance, faceDistance - 1))
                        }
                        handlePlusValue={() =>
                          changeDistance(Math.min(cameraSettings.maxDistance, faceDistance + 1))
                        }
                      />
                      <span className="slider-value">{faceDistance}cm</span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ),
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default CameraSection;
